module.exports = __webpack_public_path__ + "static/media/export.566ba208.svg";